import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import MobileNav from "@/components/MobileNav";
import WhatsAppButton from "@/components/WhatsAppButton";
import { WhatsAppProvider } from "@/lib/whatsapp";
import Home from "@/pages/Home";
import Vehicles from "@/pages/Vehicles";
import VehicleDetail from "@/pages/VehicleDetail";
import Ankauf from "@/pages/Ankauf";
import Findet from "@/pages/Findet";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Legal from "@/pages/Legal";
import Admin from "@/pages/Admin";
import { FEATURES } from "@/lib/company";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <BrowserRouter>
      <WhatsAppProvider>
        <ScrollToTop />
        <Navbar />
        <main className="min-h-screen">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/fahrzeuge" element={<Vehicles />} />
            <Route path="/fahrzeuge/:id" element={<VehicleDetail />} />
            {FEATURES.ankauf ? <Route path="/ankauf" element={<Ankauf />} /> : <Route path="/ankauf" element={<Navigate to="/" replace />} />}
            <Route path="/fahrzeugsuche" element={FEATURES.findet ? <Findet /> : <Navigate to="/fahrzeuge" replace />} />
            <Route path="/ueber-uns" element={<About />} />
            <Route path="/kontakt" element={<Contact />} />
            <Route path="/impressum" element={<Legal page="impressum" />} />
            <Route path="/datenschutz" element={<Legal page="datenschutz" />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/finanzierung" element={<Navigate to="/fahrzeuge" replace />} />
            <Route path="/autoforum-findet" element={<Navigate to={FEATURES.findet ? "/fahrzeugsuche" : "/fahrzeuge"} replace />} />
            <Route path="/payment/*" element={<Navigate to="/fahrzeuge" replace />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
        <Footer />
        <MobileNav />
        <WhatsAppButton />
        <Toaster position="top-center" richColors theme="light" />
      </WhatsAppProvider>
    </BrowserRouter>
  );
}

export default App;
